import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v2/users/get/list.ts
var list_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var UserSchema = z.object({
	active: z.boolean(),
	address: z.string().nullable(),
	emailVerified: z.boolean(),
	locked: z.boolean(),
	notes: z.string().nullable(),
	passwordResetRequired: z.boolean(),
	passwordResetToken: z.string().nullable(),
	planId: z.string(),
	planName: z.string(),
	userName: z.string(),
	uuid: z.string(),
	venue: z.boolean()
});
var ResponseSchema = z.array(UserSchema);
var parse = parseFactory(ResponseSchema);
//#endregion
export { list_exports };

//# sourceMappingURL=list.js.map